<template>
	<div class="row g-3 row-cols-2">
		<div class="col">
			<CompanyAdminHomeStatCard :link="{ name: 'company.admin.customer.index' }" :placeholder="loading" title="Clientes" :data="[{ title: 'Totales', amount: results?.customers?.total }]" :description="clientsDescription" />
		</div>
		<div class="col">
			<CompanyAdminHomeStatCard :link="{ name: 'company.admin.sale.index' }" :placeholder="loading" title="Ventas" :data="((results?.sales?.totals ?? []).length > 0) ? results?.sales?.totals : [{ title: 'Sin ventas', amount: 0 }]" description="Total de ventas de hoy" />
		</div>
	</div>
	<hr class="mt-3 mb-1">
</template>

<script>
	import { ref, computed, onMounted } from 'vue';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminReportRepository from '@/repositories/modules/Company/Admin/Report';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const results = ref([]);

			const clientsDescription = computed(() => {
				if(loading.value) return null;
				let description = [];

				if(results.value?.customers?.today > 0) description.push(`<span class='text-success'>+${results.value?.customers?.today} Hoy</span>`);
				if(results.value?.customers?.birthdays > 0) description.push(`${results.value?.customers?.birthdays} Cumpleaños`);
				if(description.length == 0) description.push('Sin novedades');

				return description.join(' · ');
			});

			onMounted(async () => {
				await CompanyAdminReportRepository.home().then((response) => {
					results.value = response.data;
				}).catch((e) => catchError(e, true));;

				loading.value = false;
			});

			return { loading, results, clientsDescription };
		}
	}
</script>